import React, { useState, useRef, useEffect } from 'react';
import api from './api/client';
import * as XLSX from 'xlsx';
import HeaderLogged from './components/header_logged';
import Container from './components/container';
import Tabs from './components/Tabs';
import TableTittle from './components/TableTittle';
import SearchAndFilter from './components/SearchAndFilter';
import Icons from './components/icons';
import Popup from './components/Popup';
import SubMenu from './components/Submenu';
import AddForm from './components/AddForm';
import { API_URL } from './config'
import DataTableWithExpandableRows from './components/DataTableWithExpandableRows';
import SecondaryTable from './components/SecondaryTable';
import UniversalDataTable from './components/UniversalDataTable';
import FlexibleSecondaryTable from './components/FlexibleSecondaryTable';
import StockPopup from './components/StockPopup';



const InventoryProducts = () => {
    // Конфигурация фильтров
    const filtersConfig = {
        individualpacketsinventory: [],
        setsinventory:[],
        wildmicrinventory:[],
        readyproductsinventory: [],
        fert_finished_stock: [],
        kits_boxes_stock: [],
    };
    
    const [filterParams, setFilterParams] = useState(() => {
        const initialFilters = {};
        for (const tab in filtersConfig) {
            filtersConfig[tab].forEach(filter => {
                if (filter.defaultValue) {
                    initialFilters[filter.field] = filter.defaultValue;
                }
            });
        }
        return initialFilters;
    });
    const setDefaultFilters = () => {
        const defaultFilters = {};
        if (Array.isArray(filtersConfig[activeTab])) {
            filtersConfig[activeTab].forEach(filter => {
                if (filter.defaultValue) {
                    defaultFilters[filter.field] = filter.defaultValue;
                }
            });
        }
        setFilterParams(defaultFilters);
    };
    
    
    useEffect(() => {
        setDefaultFilters();
    }, []);
    
    const [searchTerm, setSearchTerm] = useState('');
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [popupData, setPopupData] = useState(null);
    const [popupFields, setPopupFields] = useState([]);
    const [popupTitle, setPopupTitle] = useState('');
    const [popupSubtitle, setPopupSubtitle] = useState('');
    const [updateKey, setUpdateKey] = useState(0);
    const [activeTab, setActiveTab] = useState('individualpacketsinventory'); // Default active tab
    const [data, setData] = useState([]); // Data for the active tab
    const tableRefs = useRef({}); // Reference for table elements
    const [isStockPopupOpen, setIsStockPopupOpen] = useState(false);

    const keyFieldsConfig = {
        sets: 'SKU',
        brands: 'brandID',
        containers: 'containerID',
        seeds: 'seedsID',
        setscomposition: ['setSKU', 'sbSKU'],
        seedscategory: 'categoryID',
        employees: 'employeeID',
        emplphones: 'employeeID',
        empladdresses: 'employeeID',
        individualpackets: 'SKU',
        sbproduction: ['sku', 'emplID', 'prodDate', 'shift'],
        mbproduction: ['sku', 'emplID', 'prodDate', 'shift'],
        whlocations: 'location',
        seedslocationwh: ['seedsID', 'bagnumid'],
        masterbagsinventory: 'sku',
        smallbagsinventory: 'sku',
        individualpacketsinventory: 'SKU',
        setsinventory: 'SKU',
        wildmicr: 'SKU',
        wildmicrinventory: 'SKU',
        wildmicrproduction: ['SKU', 'emplID', 'prodDate', 'shift'],
        wildmicrmasterbagsinventory: 'sku',
        minitoolsinventory: 'brandID',
        silicagelinventory: 'brandID',
        shipmentsfbamb: ['brandID', 'shipmentID', 'SKU', 'shipmentDate'],
        shipmentsfbafb: ['brandID', 'shipmentID', 'SKU', 'shipmentDate'],
        shipmentssbss: ['brandID', 'SKU', 'shipmentDate'],
        shipmentsssmb: ['brandID', 'SKU', 'shipmentDate'],
        shipmentswildmicrss: ['brandID', 'SKU', 'shipmentDate'],
        shipmentswildmicrfba: ['brandID', 'shipmentID','SKU', 'shipmentDate'],
        workperformance: ['employeeID', 'workday', 'shift'],
        materialsuppliers: ['supplierID'],
        seedssuppliers: ['supplierID'],
        smallbagsorder: ['sku',	'orderDate'],
        masterbagsorder: ['sku','orderDate'],
        seedsorders: ['seedsID', 'supplierID', 'orderdate'],
        silicabagsorders: ['brandID', 'orderDate'],
        toolsorders: ['brandID', 'orderDate'],
        wmmasterbagsorder: ['sku','orderDate'],
        inventory_changes_log: ['logID'],
        setsboxesstock: ['sku','box'],
        bulkpacksboxesstock: ['sku','box'],
        individualsboxesstock: ['sku','box'],
        readyproductsinventory: 'SKU',
        fert_finished_stock: 'id',
        kits_boxes_stock: 'SKU',
    };

    const parseScannedData = (data) => {
        const lines = data.trim().split('\n');
    
        const parsedEntries = lines.map((line, index) => {
            const parts = line.split(',').map(part => part.trim());
            if (parts.length < 3) {
                throw new Error(`Row ${index + 1}: Incorrect data format.`);
            }
    
            // Product names may contain commas — SKU and BOX/DATE are always the last two parts
            const scannerSet = parts.slice(0, -2).join(', ');
            const sku = parts[parts.length - 2];
            const boxInfoAndDate = parts[parts.length - 1];
            const [scannerNumber, ...setNameParts] = scannerSet.split('-');
            const setName = setNameParts.join('-').trim();
    
            const boxInfoAndDateParts = boxInfoAndDate.split(' ');
            if (boxInfoAndDateParts.length < 3) {
                throw new Error(`Row ${index + 1}: Incorrect data format BOX/DATA/TIME.`);
            }
    
            const [boxInfo, date, time] = boxInfoAndDateParts;
            const [boxNumber, quantity] = boxInfo.split('/');
    
            return {
                scanner: scannerNumber.trim(),
                setName: setName.trim(),
                sku: sku,
                boxNumber: boxNumber.replace('BOX#', '').trim(),
                quantity: quantity.trim(),
                date: date.trim(),
                time: time.trim(),
                isUnsealed: sku.endsWith('_U') // Дополнительное поле для unsealed boxes
            };
        });
    
        // Удаление дубликатов по SKU и Box Number
        const uniqueEntries = [];
        const seen = new Set();
    
        parsedEntries.forEach(entry => {
            const key = `${entry.sku}-${entry.boxNumber}`;
            if (!seen.has(key)) {
                seen.add(key);
                uniqueEntries.push(entry);
            }
        });
    
        return uniqueEntries;
    };

    const handleSearch = (searchTerm) => {
        setSearchTerm(searchTerm);
    };

    const handleFilter = (params) => {
        setFilterParams(params);
        fetchTabData(`${API_URL}/api/${activeTab}`, params); // Adjust this if needed
    };
    

    const handleEdit = (data, id) => {
        const tableName = activeTab;
        const fields = tabs.find(tab => tab.name === tableName).fields.map(field => ({
            ...field,
            value: data[field.name],
        }));

        const keyFields = keyFieldsConfig[tableName];
        const initialKeyValues = Array.isArray(keyFields) ? keyFields.reduce((acc, key) => {
            acc[key] = data[key];
            return acc;
        }, {}) : { [keyFields]: data[keyFields] };

        setPopupData({ ...data, tableName, id, initialKeyValues });
        setPopupFields(fields);
        setPopupTitle(`Edit ${tableName}`);
        setPopupSubtitle(`Edit ${tableName} details`);
        setIsPopupOpen(true);
    };

    const handleClosePopup = () => {
        setIsPopupOpen(false);
        setPopupData(null);
        setPopupFields([]);

        // Увеличиваем updateKey, чтобы UniversalDataTable обновился
        setUpdateKey(prevKey => prevKey + 1);
    };

    const handlePopupSubmit = async (event) => {
        event.preventDefault();
        try {
            const updateData = popupFields.reduce((acc, field) => {
                acc[field.name] = field.value;
                return acc;
            }, {});

            const tableName = popupData.tableName;
            const keyFields = keyFieldsConfig[tableName];
            const isEditMode = !!popupData.id;

            let url;
            let method;
            let currentKeys;

            if (isEditMode) {
                // Обновление
                currentKeys = popupData.initialKeyValues;
                if (Array.isArray(keyFields)) {
                    const id = keyFields.map(key => `${key}=${currentKeys[key]}`).join('&');
                    url = `/api/${tableName}?${id}&currentKeys=${encodeURIComponent(JSON.stringify(currentKeys))}`;
                    method = 'put';
                } else {
                    const id = currentKeys[keyFields];
                    url = `/api/${tableName}/${id}?currentKeys=${encodeURIComponent(JSON.stringify(currentKeys))}`;
                    method = 'put';
                }
            } else {
                // Добавление
                url = `/api/${tableName}`;
                method = 'post';
            }

            console.log(`Sending ${method.toUpperCase()} request to: ${url}`);
            console.log('Update data:', updateData);

            const response = await api({
                method,
                url,
                data: updateData
            });

            console.log('Server response:', response.data);
            handleClosePopup();
            setUpdateKey(prevKey => prevKey + 1);
        } catch (error) {
            console.error(`Error data:`, error);
            if (error.response) {
                console.error('Server responded with:', error.response.data);
            }
        }
    };

    const handleFieldChange = (index, event) => {
        const newFields = [...popupFields];
        newFields[index].value = event.target.value;

        // Update popupData with the new value
        const updatedData = { ...popupData, [newFields[index].name]: event.target.value };
        setPopupFields(newFields);
        setPopupData(updatedData);
    };

    const handleAddClick = () => {
        if (activeTab === 'individualsboxesstock') {
            setIsStockPopupOpen(true);
        } else {
            // Стандартная логика
            const fields = tabs.find(tab => tab.name === activeTab).fields.map(field => ({
                ...field,
                value: ''
            }));
            setPopupData({ tableName: activeTab });
            setPopupFields(fields);
            setPopupTitle(`Add New ${activeTab}`);
            setPopupSubtitle(`Add new ${activeTab} details`);
            setIsPopupOpen(true);
        }
    };

    const handleStockSubmit = async (data) => {
        try {
            const formattedData = data.map(entry => {
                if (!entry.boxNumber || !entry.sku) {
                    throw new Error("Обязательные поля (boxNumber/sku) отсутствуют");
                }
                return {
                    box: String(entry.boxNumber).trim().substring(0, 10),
                    sku: String(entry.sku).trim(),
                    qty: Number(entry.quantity) || 0,
                    added_date: `${entry.date} ${entry.time}`.replace(/\//g, '-')
                };
            });
    
            const response = await api.post('/api/individualsboxesstock', {
                entries: formattedData
            });
    
            console.log('Data submitted:', response.data);
            setIsStockPopupOpen(false);
            setUpdateKey(prev => prev + 1);
        } catch (error) {
            console.error('Submission error:', error.response?.data || error.message);
            alert(`Ошибка: ${error.response?.data?.error || error.message}`);
        }
    };

    const handleAddSubmit = async (event) => {
        event.preventDefault();
        try {
            const newData = popupFields.reduce((acc, field) => {
                acc[field.name] = field.value;
                return acc;
            }, {});

            const tableName = popupData.tableName;

            console.log('handleAddSubmit newData:', newData); // Debugging line
            const response = await api.post(`/api/${tableName}`, newData);
            console.log('Server response:', response.data); // Debugging line
            handleClosePopup();
            setUpdateKey(prevKey => prevKey + 1);
        } catch (error) {
            console.error('Error adding data:', error);
            if (error.response) {
                console.error('Server responded with:', error.response.data);
            }
        }
    };

    const fetchTabData = async (endpoint) => {
        try {
            const response = await api.get(endpoint, {
                params: {
                    page: 1,
                    limit: 100, // Set a large limit to get all data
                    search: searchTerm,
                    ...filterParams
                }
            });
            console.log('Fetched Data:', response.data); // Debugging line
            setData(response.data.items);
        } catch (error) {
            console.error('Error fetching tab data:', error);
        }
    };
    const menuItems = [
        { name: 'Materials', link: '/inventory-materials' },
        { name: 'Products', link: '/inventory-products' },
        
      ];

    const tabs = [
        // {
        //     name: 'individualpacketsinventory',
        //     label: 'Individual Bags',
        //     fields: [ 
        //         { label: 'Bag', name: 'SKU', type: 'select', tableName: 'individualpackets', displayField: 'packName', updateField: 'SKU' },
        //         { label: 'Lot', name: 'lot', type: 'text' },
        //         { label: 'QTY', name: 'currentQTY', type: 'text' }
        //     ],
        //     content: (
        //         <DataTable
        //             key={updateKey}
        //             title=""
        //             columns={[
        //                 { label: 'Brand', key: 'brandID' },
        //                 { label: 'SKU', key: 'SKU' },
        //                 { label: 'Bag', key: 'packName' },
        //                 { label: 'Lot', key: 'lot' },
        //                 { label: 'QTY', key: 'currentQTY' }
        //             ]}
        //             endpoint={`${API_URL}/api/individualpacketsinventory`}
        //             searchTerm={searchTerm}
        //             filterParams={filterParams}
        //             onEdit={(data) => handleEdit(data, `${data.sku}-${data.emplID}-${data.prodDate}-${data.shift}`)}
        //             keyFieldsConfig={keyFieldsConfig}
        //             onFetchData={fetchTabData}
        //         />
        //     )
        // },
        {
            name: 'individualpacketsinventory',
            label: 'Small Packets',
            fields: [
                { label: 'Bag', name: 'SKU', type: 'select', tableName: 'individualpackets', displayField: 'packName', updateField: 'SKU' },
                { label: 'Lot', name: 'lot', type: 'text' },
                { label: 'QTY', name: 'currentQTY', type: 'text' }
            ],
            content: (
                <UniversalDataTable
                    columns={[
                        { label: 'Brand', key: 'brandName' },
                        { label: 'SKU', key: 'SKU' },
                        { label: 'Bag', key: 'packName' },
                        { label: 'QTY', key: 'currentQTY' }
                    ]}
                    endpoint={`${API_URL}/api/individualpacketsinventory`}
                    secondaryTableConfig={{
                        endpointBase: `${API_URL}/api/inventory_changes_log`,
                        columns: [
                            { key: 'logID', label: 'ID' },
                            { key: 'SKU', label: 'SKU' },
                            { key: 'previousQTY', label: 'Old QTY' },
                            { key: 'newQTY', label: 'New QTY' },
                            { key: 'quantityDifference', label: 'Difference' },
                            { key: 'changeDate', label: 'Date', type: 'datetime' },
                            { key: 'changedBy', label: 'Change By' },
                            { key: 'setName', label: 'Set Affected' },
                            { key: 'sourceTable', label: 'Source' },
                        ],
                        enableEdit: false,
                        enableDelete: false,
                        enableHistory: false
                    }}
                    keyFieldsConfig={keyFieldsConfig}
                    tableName="individualpacketsinventory" 
                    onEdit={handleEdit}
                    searchTerm={searchTerm}
                    filterParams={filterParams}
                    enableEdit={true} 
                    enableDelete={true} 
                    updateKey={updateKey}
                />
            ),
        },
        {
            name: 'setsboxesstock',
            label: 'Sets',
            fields: [
                { label: 'Set', name: 'sku', type: 'select', tableName: 'sets', displayField: 'setmane', updateField: 'SKU' },
                { label: 'Box', name: 'box', type: 'text' },
                { label: 'QTY', name: 'qty', type: 'text' },
            ],
            content: (
                <DataTableWithExpandableRows
                    columns={[
                        { key: 'sku', label: 'SKU' },
                        { key: 'setmane', label: 'Set' },
                        { key: 'box_count', label: 'Boxes QTY' },
                        { key: 'total_qty', label: 'Sets QTY' },
                        { key: 'last_added_date', label: 'Last Added Date' },
                    ]}
                    endpoint={`${API_URL}/api/setsboxesstock`}
                    secondaryTableConfig={{
                        title: 'Stock Details',
                        endpointBase: `${API_URL}/api/setsboxesstockdetails`,
                        columns: [
                            { key: 'box', label: 'Box ID' },
                            { key: 'sku', label: 'SKU' },
                            // { key: 'setmane', label: 'Set' },
                            { key: 'qty', label: 'QTY' },
                            { key: 'added_date', label: 'Date Added' },
                        ],
                        secondaryTable2: {
                            title: 'Shipment Details',
                            endpointBase: `${API_URL}/api/scannershipmentsdetails`,
                            columns: [
                                { key: 'box', label: 'Box ID' },
                                { key: 'sku', label: 'SKU' },
                                // { key: 'setname', label: 'Product' },
                                { key: 'qty', label: 'QTY' },
                                { key: 'destination', label: 'Destination' },
                                { key: 'added_date', label: 'Date Added' },
                            ],
                            enableHistory: false,
                        }
                    }}
                    keyFieldsConfig={['sku', 'box']}
                    onEdit={handleEdit}
                    searchTerm={searchTerm}
                    filterParams={filterParams}
                />
            ),
        },
        
        {
            name: 'bulkpacksboxesstock', 
            label: 'Wildflowers & Microgreens', 
            fields: [
                { label: 'Name', name: 'SKU', type: 'select', tableName: 'wildmicr', displayField: 'packName', updateField: 'SKU' },
                { label: 'Lot', name: 'lot', type: 'text' },
                { label: 'QTY', name: 'currentQTY', type: 'text' }
            ], 
            content: (
                <DataTableWithExpandableRows
                    columns={[
                        { key: 'sku', label: 'SKU' },
                        { key: 'packName', label: 'Product Name' },
                        { key: 'box_count', label: 'Boxes QTY' },
                        { key: 'total_qty', label: 'Sets QTY' },
                        { key: 'last_added_date', label: 'Last Added Date' },
                    ]}
                    endpoint={`${API_URL}/api/bulkpacksboxesstock`} 
                    secondaryTableConfig={{
                        title: 'Stock Details',
                        endpointBase: `${API_URL}/api/bulkpacksboxesstockdetails`, 
                        columns: [
                            { key: 'box', label: 'Box ID' },
                            { key: 'sku', label: 'SKU' },
                            { key: 'packname', label: 'Product Name' },
                            { key: 'qty', label: 'QTY' },
                            { key: 'added_date', label: 'Date Added' },
                        ],
                        secondaryTable2: {
                            title: 'Shipment History',
                            endpointBase: `${API_URL}/api/scannershipmentsdetails`,
                            columns: [
                                { key: 'box', label: 'Box ID' },
                                { key: 'sku', label: 'SKU' },
                                { key: 'setname', label: 'Product' },
                                { key: 'qty', label: 'QTY' },
                                { key: 'destination', label: 'Destination' },
                                { key: 'added_date', label: 'Date Added' },
                            ],
                            enableHistory: false,
                        }
                    }}
                    keyFieldsConfig={['sku', 'box']}
                    onEdit={handleEdit} 
                    searchTerm={searchTerm}
                    filterParams={filterParams}
                />
            ),          
        },
        {
            name: 'individualsboxesstock', 
            label: 'Individual Packets', 
            fields: [
                { label: 'Name', name: 'SKU', type: 'select', tableName: 'individualpackets', displayField: 'packName', updateField: 'SKU' },
                { label: 'Lot', name: 'lot', type: 'text' },
                { label: 'QTY', name: 'currentQTY', type: 'text' }
            ], 
            content: (
                <DataTableWithExpandableRows
                    columns={[
                        { key: 'sku', label: 'SKU' },
                        { key: 'packName', label: 'Product Name' },
                        { key: 'box_count', label: 'Boxes QTY' },
                        { key: 'total_qty', label: 'Sets QTY' },
                        { key: 'last_added_date', label: 'Last Added Date' },
                    ]}
                    endpoint={`${API_URL}/api/individualsboxesstock`} 
                    secondaryTableConfig={{
                        title: 'Stock Details',
                        endpointBase: `${API_URL}/api/individualsboxesstockdetails`, 
                        columns: [
                            { key: 'box', label: 'Box ID' },
                            { key: 'sku', label: 'SKU' },
                            { key: 'packName', label: 'Product Name' },
                            { key: 'qty', label: 'QTY' },
                            { key: 'added_date', label: 'Date Added' },
                        ],
                        secondaryTable2: {
                            title: 'Shipment History',
                            endpointBase: `${API_URL}/api/scannershipmentsdetails`,
                            columns: [
                                { key: 'box', label: 'Box ID' },
                                { key: 'sku', label: 'SKU' },
                                { key: 'setname', label: 'Product' },
                                { key: 'qty', label: 'QTY' },
                                { key: 'destination', label: 'Destination' },
                                { key: 'added_date', label: 'Date Added' },
                            ],
                            enableHistory: false,
                        }
                    }}
                    keyFieldsConfig={['sku', 'box']}
                    onEdit={handleEdit} 
                    searchTerm={searchTerm}
                    filterParams={filterParams}
                />
            ),          
        },
        {
            name: 'readyproductsinventory',
            label: 'Ready Products',
            fields: [
                { label: 'SKU', name: 'SKU', type: 'select', tableName: 'readyproducts', displayField: 'productName', updateField: 'SKU' },
                { label: 'QTY', name: 'currentQTY', type: 'text' },
            ],
            content: (
                <UniversalDataTable
                    columns={[
                        { label: 'Brand', key: 'brandName' },
                        { label: 'SKU', key: 'SKU' },
                        { label: 'Product Name', key: 'productName' },
                        { label: 'QTY', key: 'currentQTY' },
                    ]}
                    endpoint={`${API_URL}/api/readyproductsinventory`}
                    secondaryTableConfig={{
                        endpointBase: `${API_URL}/api/readyproductsinventory/history`,
                        columns: [
                            { key: 'id', label: 'ID' },
                            { key: 'qty_before', label: 'Before' },
                            { key: 'qty_after', label: 'After' },
                            { key: 'change_qty', label: 'Change' },
                            { key: 'source', label: 'Source' },
                            { key: 'notes', label: 'Notes' },
                            { key: 'changed_by', label: 'Changed By' },
                            { key: 'created_at', label: 'Date', type: 'datetime' },
                        ],
                        enableEdit: false,
                        enableDelete: false,
                        enableHistory: false,
                    }}
                    keyFieldsConfig={keyFieldsConfig}
                    tableName="readyproductsinventory"
                    onEdit={handleEdit}
                    searchTerm={searchTerm}
                    filterParams={filterParams}
                    enableEdit={true}
                    enableDelete={true}
                    updateKey={updateKey}
                />
            ),
        },
        {
            name: 'fert_finished_stock',
            label: 'Fertilizers',
            fields: [
                { label: 'Product', name: 'SKU', type: 'select', tableName: 'fert_products', displayField: 'productName', updateField: 'SKU' },
                { label: 'Box Number', name: 'boxNumber', type: 'text' },
                { label: 'Quantity', name: 'quantity', type: 'text' },
            ],
            content: (
                <DataTableWithExpandableRows
                    columns={[
                        { key: 'SKU',             label: 'SKU' },
                        { key: 'productName',     label: 'Product Name' },
                        { key: 'box_count',       label: 'Boxes QTY' },
                        { key: 'loose_qty',       label: 'Loose QTY' },
                        { key: 'total_qty',       label: 'Total QTY' },
                        { key: 'approx_boxes',    label: 'Approx Boxes' },
                        { key: 'last_added_date', label: 'Last Added' },
                    ]}
                    endpoint={`${API_URL}/api/fert_finished_stock`}
                    secondaryTableConfig={{
                        title: 'Box Details',
                        endpointBase: `${API_URL}/api/fert_finished_stockdetails`,
                        rowIdKey: 'SKU',
                        columns: [
                            { key: 'id',        label: 'ID' },
                            { key: 'boxNumber', label: 'Box Number' },
                            { key: 'quantity',  label: 'QTY' },
                            { key: 'addedAt',   label: 'Date Added' },
                        ],
                        enableHistory: false,
                    }}
                    keyFieldsConfig={['SKU', 'boxNumber']}
                    onEdit={handleEdit}
                    searchTerm={searchTerm}
                    filterParams={filterParams}
                />
            ),
        },

        {
            name: 'kits_boxes_stock',
            label: 'Kits',
            fields: [
                { label: 'Kit',    name: 'kit_sku', type: 'select', tableName: 'kits', displayField: 'name', updateField: 'SKU' },
                { label: 'Box #',  name: 'boxnum',  type: 'text' },
                { label: 'QTY',    name: 'qty',     type: 'text' },
            ],
            content: (
                <DataTableWithExpandableRows
                    columns={[
                        { key: 'SKU',             label: 'SKU' },
                        { key: 'kitName',          label: 'Kit Name' },
                        { key: 'box_count',        label: 'Boxes QTY' },
                        { key: 'total_qty',        label: 'Kits QTY' },
                        { key: 'last_added_date',  label: 'Last Added Date' },
                    ]}
                    endpoint={`${API_URL}/api/kits_boxes_stock`}
                    secondaryTableConfig={{
                        title: 'Stock Details',
                        endpointBase: `${API_URL}/api/kits_boxes_stockdetails`,
                        rowIdKey: 'SKU',
                        columns: [
                            { key: 'boxnum',   label: 'Box ID' },
                            { key: 'SKU',      label: 'SKU' },
                            { key: 'qty',      label: 'QTY' },
                            { key: 'added_at', label: 'Date Added' },
                        ],
                        enableHistory: false,
                        secondaryTable2: {
                            title: 'Shipment Details',
                            endpointBase: `${API_URL}/api/scannershipmentsdetails`,
                            columns: [
                                { key: 'box',         label: 'Box ID' },
                                { key: 'sku',         label: 'SKU' },
                                { key: 'qty',         label: 'QTY' },
                                { key: 'destination', label: 'Destination' },
                                { key: 'added_date',  label: 'Date Added' },
                            ],
                            enableHistory: false,
                        },
                    }}
                    keyFieldsConfig={['SKU', 'boxnum']}
                    onEdit={handleEdit}
                    searchTerm={searchTerm}
                    filterParams={filterParams}
                />
            ),
        },

        // {
        //     name: 'amazon-stock',
        //     label: 'Amazon',
        //     fields: [ 
        //     ],
        //     content: (
        //         <DataTable
        //             key={updateKey}
        //             title=""
        //             columns={[
        //                 { label: 'SKU', key: 'SKU' },
        //                 { label: 'ASIN', key: 'ASIN' },
        //                 { label: 'stock', key: 'stock' },
                        
        //             ]}
        //             endpoint={`${API_URL}/api/amazon-stock`}
        //             searchTerm={searchTerm}
        //             filterParams={filterParams}

        //             keyFieldsConfig={keyFieldsConfig}
        //             onFetchData={fetchTabData}
        //         />
        //     )
        // },
        
        
    ];

    return (
        <>
            <Icons />
            <HeaderLogged />
            {/* <SubMenu menuItems={menuItems} /> */}
            <Container>
                
                <TableTittle
                    sectionTitle="Inventory Products"
                    sectionSubtitle="Manage inventory details"
                    onAddClick={handleAddClick}
                    activeTab={activeTab}
                    tableRefs={tableRefs}
                />
                <SearchAndFilter
                    placeholder="Search by date, employee name, seeds..."
                    onSearch={handleSearch}
                    onFilter={handleFilter}
                    filtersConfig={filtersConfig[activeTab] || []}
                />
                <Tabs
                    tabs={tabs}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    tableRefs={tableRefs}
                />
            </Container>
            {popupData && (
                <Popup
                    isOpen={isPopupOpen}
                    onClose={handleClosePopup}
                    title={popupTitle}
                    subtitle={popupSubtitle}
                    fields={popupFields}
                    onFieldChange={handleFieldChange}
                    onSubmit={handlePopupSubmit}
                />
            )}
            {isStockPopupOpen && (
            <StockPopup
                isOpen={isStockPopupOpen}
                onClose={() => setIsStockPopupOpen(false)}
                onSubmit={handleStockSubmit}
                onParse={parseScannedData}
            />
        )}
        </>
    );
};

export default InventoryProducts;
